import React, { Component } from 'react';
import { get, has } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioCheckButton from '../../../shared/items/controls/radioCheckButton';
import WorkHardNextStepButton from "./workHardNextStepButton"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { workHardData } from "./static.workHardData"
import { steps } from "../../../shared/static.steps"
import locales from "./../../../content.json"

import "./../../../shared/services/service.step.scss"

class WorkHard extends Component {
  constructor() {
    super();

    this.state = {
      isOpenWorkHard: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.workHard) && !this.state.isOpenWorkHard)
      this.setState({ isOpenWorkHard: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData } = this.props
    const { isOpenWorkHard } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.workHard,
      isOpen: isOpenWorkHard,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenWorkHard && !has(data, ["workHard"]))
      onSetStepData("workHard")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenWorkHard: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenWorkHard } = this.state
    const params = {
      className: "wrapperWorkHard",
      currentIndex: currentIndex,
      stepIndex: steps.workHard,
    }

    return isOpenWorkHard ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>{locales[window.userLang].hard_ask}</FirstTitle>

          {
            Object.keys(workHardData).map((key, index) => {
              return (
                <RadioCheckButton
                  key={index}
                  isChecked={get(data, ["workHard", "value"], null) === workHardData[key].value}
                  onClick={() => {
                    if (get(data, ["workHard", "value"], null) !== workHardData[key].value) {
                      onUpdateStepData.bind(this, "workHard", "value", workHardData[key].value)();
                      setTimeout(this.props.onToNextStep, 300);
                    }
                  }}
                >
                  {workHardData[key].title}
                </RadioCheckButton>
              )
            })
          }
        </StepContentWrapper>
      </div>
      : null
  }
}

export default withStepsState(WorkHard);